import { Form, Radio as AntDRadio } from 'antd'

import { useField } from 'formik'
import PropTypes from 'prop-types'


const { Item } = Form

export default function RadioButton({
  containerClassName = undefined,
  label = '',
  options = [],
  layout = undefined,
  ...rest
}) {
  const [field, { error, touched }] = useField(rest)
  const hasError = Boolean(touched && error)

  return (
    <Item
      className={containerClassName}
      label={label}
      validateStatus={hasError ? 'error' : ''}
      help={hasError && error}
      layout={layout}
    >
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <AntDRadio.Group options={options} {...field} {...rest} />
    </Item>
  )
}

RadioButton.propTypes = {
  containerClassName: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string),
  label: PropTypes.string,
  layout: PropTypes.string,
}
